<template>
  <q-dialog ref="dialog" @hide="onDialogHide">
    <q-card class="q-dialog-plugin">
      <q-card-section>
        <div class="text-h6">{{ headerText }}</div>
        <q-separator />
        <div class="text-subtitle2">{{ text }}</div>
      </q-card-section>
      <q-card-actions align="right">
        <q-btn class="s-btn" unelevated :label="cancelLabel" @click="onCancelClick" />
        <q-btn class="s-btn--inverse" unelevated :label="confirmLabel" @click="onOKClick" />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  props: {
    headerText: {
      required: false,
      type: [Number, String],
      default: 'Confirm delete',
    },
    text: {
      required: false,
      type: [Number, String],
      default: 'Do you really want to delete a document?',
    },
    confirmLabel: {
      required: false,
      type: [Number, String],
      default: 'Yes',
    },
    cancelLabel: {
      required: false,
      type: [Number, String],
      default: 'No',
    },
  },

  methods: {
    // following method is REQUIRED
    // (don't change its name --> "show")
    show() {
      this.$refs.dialog.show();
    },

    // following method is REQUIRED
    // (don't change its name --> "hide")
    hide() {
      this.$refs.dialog.hide();
    },

    onDialogHide() {
      // required to be emitted
      // when QDialog emits "hide" event
      this.$emit('hide');
    },

    onOKClick() {
      // on OK, it is REQUIRED to
      // emit "ok" event (with optional payload)
      // before hiding the QDialog
      this.$emit('ok');
      // or with payload: this.$emit('ok', { ... })

      // then hiding dialog
      this.hide();
    },

    onCancelClick() {
      // we just need to hide dialog
      this.hide();
    },
  },
});
</script>
